import {useCart} from '@shopify/hydrogen';
import {toast} from 'react-toastify';

export function useToast() {
  const {totalQuantity} = useCart();

  const handleCartTotalChange = (adjustment) => {
    const toastMessage =
      adjustment > 0
        ? `Item added to cart (${totalQuantity + adjustment}).`
        : `Item removed from cart (${totalQuantity + adjustment}).`;

    toast.success(toastMessage, {
      position: 'bottom-right',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
    });
  };

  return {
    handleCartTotalChange,
  };
}
